/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const S1_TYPHOON_IDAI_WORKFLOW_AREA = {
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "properties": { areaName: "Area 1", },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                33.98895263671875,
                -20.56079574020845
              ],
              [
                35.3265380859375,
                -20.56079574020845
              ],
              [
                35.3265380859375,
                -19.155546551403607
              ],
              [
                33.98895263671875,
                -19.155546551403607
              ],
              [
                33.98895263671875,
                -20.56079574020845
              ]
            ]
          ]
        }
      }
    ]
  }
  ;

export default S1_TYPHOON_IDAI_WORKFLOW_AREA;